import { createFileRoute } from '@tanstack/react-router'
import { ReleaseNotesPage } from '@/components/ReleaseNotes/ReleaseNotesPage'
import { useAuth } from '@/hooks/useAuth'
import { LoginRequiredEmptyState } from '@/components/EmptyStates/LoginRequiredEmptyState'
import { withPublicPageSeo } from '@/modules/seo'

function UpdatesPage() {
  const { isAuthenticated } = useAuth()

  if (!isAuthenticated) {
    return (
      <LoginRequiredEmptyState />
    )
  }

  return <ReleaseNotesPage />
}

const UpdatesPageWithSeo = withPublicPageSeo('updates', UpdatesPage)

export const Route = createFileRoute('/updates/')({
  component: UpdatesPageWithSeo,
})
